module.exports = __webpack_public_path__ + "img/store.2f8ded92.svg";